import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";

function Storung(props) {

    const [storungData, setStorungData] = useState([]);




    useEffect(() => {
        /*let filteredDevicesDuplicates = []
        for (let i = 0; i < props.geraeteData?.length; i++) {
            let deviceEntry = {
                "id": "", "name": ""
            }
            if (!isDeviceAlreadyThere(filteredDevicesDuplicates, props.geraeteData[i]?.id)) {
                deviceEntry.id = props.geraeteData[i]?.id
                deviceEntry.name = props.geraeteData[i]?.name
                filteredDevicesDuplicates.push(deviceEntry)
            }
        }*/
        setStorungData(props.storung)
    }, [props]);


    function getStorungTableBody(storungData) {
        return storungData?.map((item) => (<tr key={item.taetigkeitID}>
            <td>{item.titel}</td>

        </tr>));
    }

    return (<>
        <Row>
            <Col>
                <label className="handwai-text-label-main add-bottom-0-margin">{"Störung(en)"}</label>
            </Col>

        </Row>
        <br/>
        <table id="storungTable" className="table handwai-white-text">
            <thead>
            <tr>
                <th>Titel</th>
            </tr>
            </thead>
            <tbody>{getStorungTableBody(storungData)}</tbody>
        </table>
        </>);
}

export default Storung;